import _ from 'underscore';

export default class UserSellerSidebarMenu {
  constructor($scope, UserSidebarService) {
    var menu = [
      {
        group: 0,
        title: 'Preview',
        pages: [{
          title: 'Preview',
          action: 'edit_preview'
        }]
      },
      {
        group: 1,
        title: 'Overview',
        pages: [{
          title: 'Overview',
          action: 'overview'
        }]
      },
      {
        group: 2,
        title: 'Accounts & Personal Data',
        pages: [{
          title: 'Manage Contacts',
          action: 'edit_company_contacts'
        }]
      },
      {
        group: 2,
        title: 'Main Details - Company Profile',
        pages: [{
          title: 'Company Details',
          action: 'edit_company_details'
        }]
      },
      {
        group: 3,
        title: 'Usual Infos - Trading Terms',
        pages: [
          {
            title: 'General',
            action: 'edit_trading_general'
          },
          {
            title: 'Offer Details',
            action: 'edit_trading_offer'
          },
          {
            title: 'Order Details',
            action: 'edit_trading_order'
          },
          {
            title: 'Delivery Terms',
            action: 'edit_trading_delivery'
          },
          {
            title: 'Freight Rates',
            action: 'edit_trading_freight'
          },
          {
            title: 'Acceptable Payment Terms',
            action: 'edit_trading_payment'
          },
          {
            title: 'Special Payment Terms',
            action: 'edit_trading_special_payment'
          },
          {
            title: 'Market Restrictions',
            action: 'edit_trading_restrictions'
          }
        ]
      },
      {
        group: 3,
        title: 'Product Preferences',
        pages: [
          {
            title: 'Categories & Groups',
            action: 'edit_preferences_categories'
          },
          {
            title: 'Product Qualities',
            action: 'edit_preferences_products'
          },
          {
            title: 'Product Quality Groups',
            action: 'edit_preferences_product_groups'
          },
          {
            title: 'Product Brands',
            action: 'edit_preferences_brands'
          },
          {
            title: 'Product Volumes & Uses',
            action: 'edit_preferences_volumes'
          },
          {
            title: 'Product Pricings',
            action: 'edit_preferences_pricings'
          }
        ]
      },
      {
        group: 3,
        title: 'Special Price Policy',
        pages: [
          {
            title: 'Buyer Special Pricings',
            action: 'edit_spp_buyer_pricings'
          },
          {
            title: 'Special Pricings (USPP)',
            action: 'edit_spp_special_pricings'
          },
          {
            title: 'Special Charges by User (USCP)',
            action: 'edit_spp_special_user_charges'
          },
          {
            title: 'Special Charges by Country (SCCP)',
            action: 'edit_spp_special_country_charges'
          },
          {
            title: 'Special Charges by Incoterm (SCIP)',
            action: 'edit_spp_special_incoterm_charges'
          }
        ]
      },
      {
        group: 3,
        title: 'Offers & Inventories',
        pages: [
          {
            title: 'Spot Offers',
            action: 'edit_offer_spot'
          },
          {
            title: 'Inventories',
            action: 'edit_offer_inventories'
          }
        ]
      },
      {
        group: 4,
        title: 'Matched Demands & Buyers',
        pages: [
          {
            title: 'My Matched Requests/Demands',
            action: 'edit_matched_my'
          },
          {
            title: 'Matched Buyers',
            action: 'edit_matched_buyers'
          },
          {
            title: 'Favorite Requests/Demands',
            action: 'edit_matched_favorite_requests'
          },
          {
            title: 'Favorite Buyers',
            action: 'edit_matched_favorite_buyers'
          }
        ]
      },
      {
        group: 5,
        title: 'Special Section',
        pages: [
          {
            title: 'FAQs',
            action: 'edit_special_faqs'
          },
          {
            title: 'Roll Messages',
            action: 'edit_special_roll_messages'
          }
        ]
      },
      {
        group: 5,
        title: 'Campaign Alerts & Notifications',
        pages: [{
          title: 'Campaign Alerts & Notifications',
          action: 'edit_alerts'
        }]
      },
      {
        group: 5,
        title: 'Reports & Stats',
        pages: [{
          title: 'Reports & Stats',
          action: 'edit_reports'
        }]
      },
      {
        group: 5,
        title: 'Create Options',
        pages: [
          {
            title: 'Create new Spot Offer or Inventory',
            action: 'edit_create_spot'
          },
          {
            title: 'Create new Offers based to others',
            action: 'edit_create_offer'
          }
        ]
      },
      {
        group: 6,
        title: 'Orders & Offer Requests',
        pages: [
          {
            title: 'Selections',
            action: 'offer_request_selections'
          },
          {
            title: 'Reservations',
            action: 'offer_request_reservations'
          },
          {
            title: 'Orders',
            action: 'edit_orders'
          },
          {
            title: 'Arrivals',
            action: 'edit_arrivals'
          },
          {
            title: 'Payment Notifications',
            action: 'edit_orders_payment'
          },
          {
            title: 'Customers',
            action: 'edit_orders_customers'
          },
          {
            title: 'Sales Confirmations',
            action: 'edit_sales_confirmations'
          }
        ]
      }
    ];

    $scope.set_page_data = function(section_index, page_index, data) {
      var section = $scope.menu[section_index];
      var page = section.pages[page_index];
      page.data = data;
    };

    $scope.$on('set_sidebar_data', function(event, data) {
      $scope.set_page_data(data[0], data[1], data[2]);
    });

    function set_menu() {
      var section = _.find(menu, function(section) {
        return _.contains(_.pluck(section.pages, 'action'), window.app_data.action);
      });

      if (section) {
        $scope.menu = _.where(menu, {
          group: section.group
        });
        var groups_with_data = [2, 3, 6];
        if (_.contains(groups_with_data, section.group)) {
          UserSidebarService.get_sidebar_data(window.app_data.user_id, section.group).success(function(data) {
            var sidebar_data = data.sidebar_data;
            if (section.group === 2) {
              $scope.set_page_data(0, 0, [{
                type: 'counter',
                value: sidebar_data.contacts_count
              }, {
                type: 'counter',
                value: sidebar_data.accounts_count
              }]);
              $scope.set_page_data(1, 0, [{
                type: 'percentage',
                value: sidebar_data.company_percentage
              }]);
            } else if (section.group === 3) {
              $scope.set_page_data(0, 0, [{
                type: 'percentage',
                value: sidebar_data.trading_percentage
              }]);
              $scope.set_page_data(0, 1, [{
                type: 'percentage',
                value: sidebar_data.offer_percentage
              }]);
              $scope.set_page_data(0, 2, [{
                type: 'percentage',
                value: sidebar_data.order_percentage
              }]);
              $scope.set_page_data(0, 3, [{
                type: 'counter',
                value: sidebar_data.delivery_terms_count
              }]);
              $scope.set_page_data(0, 4, [{
                type: 'counter',
                value: sidebar_data.freight_rates_count
              }]);
              $scope.set_page_data(0, 5, [{
                type: 'counter',
                value: sidebar_data.payment_terms_count
              }]);
              $scope.set_page_data(0, 6, [{
                type: 'counter',
                value: sidebar_data.special_payment_terms_count
              }]);
              $scope.set_page_data(0, 7, [{
                type: 'counter',
                value: sidebar_data.restrictions_count
              }]);
              $scope.set_page_data(1, 0, [{
                type: 'counter',
                value: sidebar_data.categories_count
              }, {
                type: 'counter',
                value: sidebar_data.groups_count
              }]);
              $scope.set_page_data(1, 1, [{
                type: 'counter',
                value: sidebar_data.epaper_products_count
              }, {
                type: 'counter',
                value: sidebar_data.products_count
              }]);
              $scope.set_page_data(1, 3, [{
                type: 'counter',
                value: sidebar_data.brands_count
              }]);
              $scope.set_page_data(1, 4, [{
                type: 'counter',
                value: sidebar_data.product_volumes.count
              }, {
                type: 'percentage',
                value: sidebar_data.product_volumes.percentage
              }]);
              $scope.set_page_data(1, 5, [{
                type: 'counter',
                value: sidebar_data.supplier_product_count
              }, {
                type: 'counter',
                value: sidebar_data.supplier_group_count
              }]);
              $scope.set_page_data(2, 0, [{
                type: 'counter',
                value: sidebar_data.spp_buyers_count
              }, {
                type: 'counter',
                value: sidebar_data.spp_count
              }, {
                type: 'counter',
                value: sidebar_data.spp_check_count
              }]);
              $scope.set_page_data(2, 2, [{
                type: 'counter',
                value: sidebar_data.special_charges_count
              }]);
            } else if (section.group === 6) {
              $scope.set_page_data(0, 0, [{
                type: 'counter',
                value: sidebar_data.selections_count
              }]);
              $scope.set_page_data(0, 1, [{
                type: 'counter',
                value: sidebar_data.reservations_count
              }]);
              $scope.set_page_data(0, 2, [{
                type: 'counter',
                value: sidebar_data.orders_count
              }]);
            }
          });
        }
      }
    }

    $scope.init = function() {
      $scope.menu = [];
      set_menu();
    };

    $scope.init();

  }
}

UserSellerSidebarMenu.$inject = ['$scope', 'UserSidebarService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/user-seller-sidebar-menu.ctrl.js